<script lang="ts" setup>
import { definePageMeta } from '#imports'
import Desktop from '~/components/desktop/home/index.vue'
import Mobile from '~/components/mobile/home/index.vue'

definePageMeta({
  pageTransition: {
    mode: 'default',
  },
})
const { component } = useResponsiveComponent(Desktop, Mobile)
</script>

<template>
  <component :is="component" />
</template>
